// Detects when a newer build has been deployed while the app is open (the
// running tab keeps its old JS on SPA navigation) and offers a one-click
// reload. Compares the running main bundle filename to the one referenced by
// the freshly-fetched index.html.
import { useEffect, useState } from 'react';

const runningBundle = (): string | null => {
  const s = document.querySelector(
    'script[type="module"][src*="/assets/index-"]'
  ) as HTMLScriptElement | null;
  return s?.src ? s.src.split('/').pop() || null : null;
};

export const VersionChecker: React.FC = () => {
  const [stale, setStale] = useState(false);

  useEffect(() => {
    const running = runningBundle();
    if (!running) return; // dev server / can't determine — skip

    let stopped = false;
    const check = async () => {
      try {
        const html = await fetch(`/?v=${Date.now()}`, { cache: 'no-store' }).then((r) => r.text());
        const m = html.match(/assets\/index-[A-Za-z0-9_-]+\.js/);
        const latest = m ? m[0].split('/').pop() : null;
        if (!stopped && latest && latest !== running) setStale(true);
      } catch {
        /* offline / transient — ignore */
      }
    };

    const interval = setInterval(check, 90_000);
    const onVisible = () => { if (document.visibilityState === 'visible') check(); };
    document.addEventListener('visibilitychange', onVisible);
    // first check shortly after load
    const t = setTimeout(check, 8_000);

    return () => {
      stopped = true;
      clearInterval(interval);
      clearTimeout(t);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);

  if (!stale) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 99999,
      display: 'flex', justifyContent: 'center', pointerEvents: 'none',
    }}>
      <div style={{
        margin: 10, padding: '9px 10px 9px 18px', borderRadius: 999,
        background: 'linear-gradient(135deg, #00c2b3, #0077b6)', color: '#fff',
        display: 'flex', alignItems: 'center', gap: 14, pointerEvents: 'all',
        boxShadow: '0 10px 30px rgba(0,0,0,0.4)', fontFamily: 'Outfit, sans-serif',
        fontSize: 13, fontWeight: 600,
      }}>
        A new version of GathrXR is available
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: '6px 16px', borderRadius: 999, border: 'none',
            background: 'rgba(255,255,255,0.95)', color: '#04101c',
            fontWeight: 700, fontSize: 12.5, cursor: 'pointer', fontFamily: 'Outfit, sans-serif',
          }}
        >
          Reload
        </button>
      </div>
    </div>
  );
};
